$(window).on("load", function () {
	const body = $("body");
	const toggle = $("#menu-toggle");
	const nav = $("#main-nav");

	toggle.on("click", function () {
		if (toggle.hasClass("active")) {
			toggle.removeClass("active");
			nav.removeClass("open");
			body.removeClass("fixed");
			// nav.slideUp();
			toggle.attr("aria-expanded", "false");
		} else {
			body.addClass("fixed");
			toggle.addClass("active");
			nav.addClass("open");
			// nav.slideDown(200);
			toggle.attr("aria-expanded", "true");
		}
		// nav_tl.reversed(!nav_tl.reversed());
	});

	$(".sub-menu-toggle-btn").on("click", function() {
		let myTrigger = $(this);
		let mySubmenu = $(this).next("ul.submenu");
		if (mySubmenu.hasClass("active")) {
			mySubmenu.removeClass("active");
			mySubmenu.slideUp();
			myTrigger.removeClass("open");
			myTrigger.attr("aria-expanded", "false");
		} else {
			mySubmenu.addClass("active");
			mySubmenu.slideDown(200);
			myTrigger.addClass("open");
			myTrigger.attr("aria-expanded", "true");
		}

	});

	$('.collapseable').next().slideUp();

	$('.collapseable').on('click', function(){
		$(this).toggleClass('open');
		$(this).next().slideToggle();
	});
});
